var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOurVision(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m475.429 124.113c20.984 39.769 36.571 83.645 36.571 131.887 0 141.385-114.615 256-256 256s-256-114.615-256-256 114.615-256 256-256c49.118 0 96.997 15.031 135.97 39.014 0 0 60.43 41.452 83.459 85.099z",
    fill: "#ff405c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m512 256c0-48.242-15.587-92.118-36.57-131.887-23.03-43.647-83.46-85.099-83.46-85.099-38.973-23.983-86.852-39.014-135.97-39.014v512c141.385 0 256-114.615 256-256z",
    fill: "#c1126b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m404.654 182.222c10.922 23.293 17.257 46.275 17.257 73.778 0 91.63-74.281 165.912-165.912 165.912s-165.911-74.282-165.911-165.912 74.282-165.912 165.912-165.912c28.943 0 53.868 6.169 77.555 19.197 0 .001 50.4 28.793 71.099 72.937z",
    fill: "#fff4f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m421.912 256c0-27.504-6.335-50.485-17.257-73.778-20.699-44.143-71.099-72.936-71.099-72.936-23.688-13.028-48.613-19.198-77.556-19.198v331.823c91.63.001 165.912-74.281 165.912-165.911z",
    fill: "#eee1dc"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    fill: "#ff405c",
    r: 78.098
  }), /*#__PURE__*/React.createElement("path", {
    d: "m334.098 256c0-43.132-34.966-78.098-78.098-78.098v156.196c43.132 0 78.098-34.966 78.098-78.098z",
    fill: "#c1126b"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m252.843 276.782c-4.057 0-8.111-1.554-11.196-4.659-6.142-6.183-6.109-16.175.073-22.318l194.76-193.48c6.184-6.142 16.176-6.108 22.318.073 6.142 6.183 6.109 16.176-.073 22.318l-194.76 193.48c-3.079 3.058-7.101 4.586-11.122 4.586z",
    fill: "#00337a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m458.371 48.586-14.378-41.518c-2.378-6.867-11.122-8.877-16.26-3.739l-81.608 81.608c-2.368 2.368-3.369 5.777-2.658 9.049l11.982 55.15c.782 3.6 3.509 6.462 7.067 7.416l56.665 15.206c3.397.912 7.023-.059 9.511-2.546l80.423-80.423c4.908-4.908 3.331-13.217-3.034-15.985l-42.335-18.413c-2.525-1.098-4.475-3.203-5.375-5.805z",
    fill: "#00aeee"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m458.798 56.398c-.12-.121-.251-.224-.374-.34l-216.404 216.405c3.036 2.868 6.924 4.319 10.822 4.319 4.021 0 8.044-1.528 11.122-4.585l194.76-193.48c6.184-6.143 6.217-16.135.074-22.319z",
    fill: "#002659"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m506.051 72.834-42.335-18.413c-.824-.358-1.579-.834-2.264-1.389l-102.072 102.071c.931.657 1.97 1.174 3.107 1.479l56.665 15.206c3.397.912 7.023-.059 9.511-2.546l80.423-80.423c4.907-4.908 3.33-13.217-3.035-15.985z",
    fill: "#0089ff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOurVision);
export default __webpack_public_path__ + "static/media/our-vision.7f630901b753dcbe4ed491ee34639b4f.svg";
export { ForwardRef as ReactComponent };